import {
    getDetails,
    getDetailsFailure,
    getDetailsSuccess,
    setDescriptionLoaded,
    setDetailsEpisode,
    setDetailsEpisodeCastAndCrew,
    setUnlockId,
} from 'store/details/actions';
import {
    GET_DETAILS,
    GET_DETAILS_FAILURE,
    GET_DETAILS_SUCCESS,
    SET_DESCRIPTION_LOADED,
    SET_DETAILS_EPISODE,
    SET_DETAILS_EPISODE_CAST_AND_CREW,
    SET_UNLOCKED_PAGE,
} from 'store/details/constants';
import {
    DetailsState,
    DetailsStateOnTemplate,
} from 'store/details/reducer.types';
import { RequestStatus } from 'store/utils';

const initialState: DetailsState = {
    detailsByTemplateId: {},
    unlockedId: undefined,
};

export const initialStateOnTemplate: DetailsStateOnTemplate = {
    details: undefined,
    detailsLoading: false,
    detailsError: undefined,
    descriptionLoading: false,
    detailsRequest: RequestStatus.IDLE,
    castAndCrew: [],
};

const handlers = {
    [GET_DETAILS](
        state: DetailsState,
        { payload: { templateId, silently } }: ReturnType<typeof getDetails>,
    ): DetailsState {
        return {
            ...state,
            detailsByTemplateId: {
                ...state.detailsByTemplateId,
                [templateId]: {
                    ...state.detailsByTemplateId[templateId],
                    ...initialStateOnTemplate,
                    detailsLoading: !silently,
                    descriptionLoading: !silently,
                    detailsRequest: silently
                        ? state.detailsByTemplateId[templateId].detailsRequest
                        : RequestStatus.PENDING,
                    detailsError: silently
                        ? state.detailsByTemplateId[templateId].detailsError
                        : undefined,
                },
            },
        };
    },
    [GET_DETAILS_SUCCESS](
        state: DetailsState,
        {
            payload: { details, castAndCrew, templateId },
        }: ReturnType<typeof getDetailsSuccess>,
    ): DetailsState {
        return {
            ...state,
            detailsByTemplateId: {
                ...state.detailsByTemplateId,
                [templateId]: {
                    ...state.detailsByTemplateId[templateId],
                    detailsLoading: false,
                    details,
                    detailsError: undefined,
                    detailsRequest: RequestStatus.SUCCESS,
                    descriptionLoading:
                        state.detailsByTemplateId[templateId]
                            ?.descriptionLoading || false,

                    castAndCrew,
                },
            },
        };
    },
    [GET_DETAILS_FAILURE](
        state: DetailsState,
        {
            payload: { message, code, templateId },
        }: ReturnType<typeof getDetailsFailure>,
    ): DetailsState {
        return {
            ...state,
            detailsByTemplateId: {
                ...state.detailsByTemplateId,
                [templateId]: {
                    ...state.detailsByTemplateId[templateId],
                    detailsLoading: false,
                    details: undefined,
                    descriptionLoading: false,
                    detailsError: {
                        message,
                        code,
                    },
                    detailsRequest: RequestStatus.FAILURE,
                },
            },
        };
    },
    [SET_DESCRIPTION_LOADED](
        state: DetailsState,
        { payload: { templateId } }: ReturnType<typeof setDescriptionLoaded>,
    ): DetailsState {
        return {
            ...state,
            detailsByTemplateId: {
                ...state.detailsByTemplateId,
                [templateId]: {
                    ...initialStateOnTemplate,
                    ...state.detailsByTemplateId[templateId],
                    descriptionLoading: false,
                },
            },
        };
    },
    [SET_UNLOCKED_PAGE](
        state: DetailsState,
        { payload }: ReturnType<typeof setUnlockId>,
    ): DetailsState {
        return {
            ...state,
            unlockedId: payload,
        };
    },

    [SET_DETAILS_EPISODE](
        state: DetailsState,
        {
            payload: { templateId, episode },
        }: ReturnType<typeof setDetailsEpisode>,
    ): DetailsState {
        return {
            ...state,
            detailsByTemplateId: {
                ...state.detailsByTemplateId,
                [templateId]: {
                    ...state.detailsByTemplateId[templateId],
                    details: episode,
                },
            },
        };
    },

    [SET_DETAILS_EPISODE_CAST_AND_CREW](
        state: DetailsState,
        {
            payload: { templateId, castAndCrew },
        }: ReturnType<typeof setDetailsEpisodeCastAndCrew>,
    ): DetailsState {
        return {
            ...state,
            detailsByTemplateId: {
                ...state.detailsByTemplateId,
                [templateId]: {
                    ...state.detailsByTemplateId[templateId],
                    castAndCrew,
                },
            },
        };
    },
};

export default { initialState, handlers };
